import _ from 'lodash'
import i18next from 'i18next'
import moment from '../helpers/moment'

// PUBLIC METHODS
function getClassDisplayTime({
  date,
  fromTime,
  toTime,
  timeFormat = 'LT',
  dateFormat = 'L',
}) {
  return _.join(
    _.compact([
      // time
      _.join(
        _.map(
          // prevent duplicate times
          _.uniq(_.compact([fromTime, toTime])),
          (time) => moment(time).format(timeFormat),
        ),
        ' - ',
      ),
      // date
      date && moment(date).format(dateFormat),
    ]),
    ' ',
  )
}

function getSkuQuotaDetails({
  skuQuota,
  skuQuotaQuotaTypeOverride,
  translationKeyPrefixOverride: tkpo,
}) {
  if (_.isEmpty(skuQuota)) return {}
  const quotaType = _.camelCase(skuQuotaQuotaTypeOverride || _.get(skuQuota, 'quotaType', 'booking'))
  const salesperson = _.get(skuQuota, 'salesperson.alias') || _.get(skuQuota, 'salesperson.name')
  const fromTime = _.get(skuQuota, 'fromTimeTimestamp')
  const toTime = _.get(skuQuota, 'toTimeTimestamp')
  const store = _.get(skuQuota, 'store.name', '')
  const location = _.get(skuQuota, 'storeLocation.name', '')
  return {
    salesperson: i18next.t(
      _.compact([tkpo && `${tkpo}.salesperson`, 'ui.skuSkuQuotaItem.salesperson']),
      {
        name: salesperson,
        context: quotaType,
      },
    ),
    store: i18next.t(
      _.compact([tkpo && `${tkpo}.store`, 'ui.skuSkuQuotaItem.store']),
      {
        store,
        location,
        context: quotaType,
      },
    ),
    storeLocation: _.has(skuQuota, 'storeLocation.name')
      ? i18next.t(_.compact([tkpo && `${tkpo}.storeLocation`, 'ui.skuSkuQuotaItem.storeLocation']), {
        location,
        defaultValue: '{{location}}',
        context: quotaType,
      })
      : '',
    date: i18next.t(_.compact([tkpo && `${tkpo}.date`, 'ui.skuSkuQuotaItem.date']), {
      date: moment(fromTime).format('L'),
      defaultValue: '{{date}}',
      context: quotaType,
    }),
    time: i18next.t(_.compact([tkpo && `${tkpo}.time`, 'ui.skuSkuQuotaItem.time']), {
      time: getClassDisplayTime({
        fromTime,
        toTime,
      }),
      defaultValue: '{{time}}',
      context: quotaType,
    }),
  }
}

export default {
  getClassDisplayTime,
  getSkuQuotaDetails,
}
